import PropTypes from 'prop-types';

const SetPassword = ({ strings, isReset }) => {
  const { emailSent, resetPasswordEmailSent, setPasswordEmailSent } = strings;
  return (
    <div>
      <h1 className="page-heading">{emailSent}</h1>
      <p>{isReset ? resetPasswordEmailSent : setPasswordEmailSent}</p>
    </div>
  );
};

SetPassword.propTypes = {
  isReset: PropTypes.bool,
  strings: PropTypes.object.isRequired,
};

SetPassword.defaultProps = {
  isReset: false,
};

export default SetPassword;
